import React from 'react';
import { Backdrop, CircularProgress } from '@material-ui/core';

export function EeLoadingArea(props: any) {
  return (
    <Backdrop
      open
      style={{
        position: props.position ? props.position : 'relative',
        zIndex: 1,
        backgroundColor: '#ebeff3',
      }}
      className="lens-loader-warper"
    >
      <CircularProgress style={{ color: '#f6ba07' }} className="lens-loader" />
    </Backdrop>
  );
}
